import { render, staticRenderFns } from "./NewScanPage.vue?vue&type=template&id=62162f88&scoped=true"
import script from "./NewScanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewScanPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewScanPage.vue?vue&type=style&index=0&id=62162f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62162f88",
  null
  
)

export default component.exports